(function () {
  const GIFT_VARIANT_ID = 47722151674092;
  const THRESHOLD = 200000; // 2000 TL
  let isUpdating = false;
  let timer = null;

  async function getCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    return await res.json();
  }

  async function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
    });
  }

  async function removeGift(giftKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftKey, quantity: 0 })
    });
  }

  async function syncGift() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const cart = await getCart();

      const giftItems = cart.items.filter(item => item.variant_id === GIFT_VARIANT_ID);
      const gift = giftItems[0];

      const subtotalWithoutGift = cart.items
        .filter(item => item.variant_id !== GIFT_VARIANT_ID)
        .reduce((total, item) => total + item.final_line_price, 0);

      if (giftItems.length > 1) {
        for (let i = 1; i < giftItems.length; i++) {
          await removeGift(giftItems[i].key);
        }
        location.reload();
        return;
      }

      if (gift && gift.quantity > 1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gift.key, quantity: 1 })
        });
        location.reload();
        return;
      }

      if (subtotalWithoutGift >= THRESHOLD && !gift) {
        await addGift();
        location.reload();
        return;
      }

      if (subtotalWithoutGift < THRESHOLD && gift) {
        await removeGift(gift.key);
        location.reload();
        return;
      }
    } catch (error) {
      console.error('Free gift error:', error);
    } finally {
      isUpdating = false;
    }
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(syncGift, 600);
  }

  document.addEventListener('DOMContentLoaded', syncGift);
  document.addEventListener('change', scheduleSync);
  document.addEventListener('click', scheduleSync);

  const originalFetch = window.fetch;
  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);
    const url = String(arguments[0]);

    if (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    ) {
      scheduleSync();
    }

    return response;
  };
})();